<template>
  <v-dialog
    v-model="modelValue"
    persistent
    max-width="800px"
    content-class="client-form-dialog"
  >
    <v-card class="pa-4" v-if="loading">
      <v-progress-circular indeterminate color="primary" />
    </v-card>

    <ClientForm
      v-if="initialData"
      :key="clientId"
      :model-value="initialData"
      @update:modelValue="handleFormSaved"
    />
  </v-dialog>
</template>

<script>
import api from '../api'
import ClientForm from './ClientForm.vue'

export default {
  components: {
    ClientForm,
  },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  emits: ['update:modelValue'],

  props: {
    clientId: {
      type: Number,
      required: true,
    },

    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      initialData: null,
    }
  },

  watch: {
    modelValue: {
      handler(opened) {
        if (opened) {
          this.loadData()
        }
      },
      immediate: true,
    },
  },

  methods: {
    loadData() {
      if (this.clientId === -1) {
        this.initialData = {}
        return
      }

      this.initialData = null
      this.loading = true

      api.endpoints.clients
        .getOne({ id: this.clientId })
        .then(response => {
          this.initialData = response.data
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },

    handleFormSaved(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>
